export default __webpack_public_path__ + "static/media/popupTransitionFree.e8d5296f.m4v";